import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { FaGithubSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { SiLeetcode } from "react-icons/si";
import { FaMedium } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header_socials">
      <a
        href="https://www.linkedin.com/in/pranav-tripathi2510/"
        target="_blank"
      >
        <FaLinkedin />
      </a>
      <a href="https://github.com/codiac1" target="_blank">
        <FaGithubSquare />
      </a>
      <a href="https://leetcode.com/Pranav_2510/" target="_blank">
        <SiLeetcode />
      </a>
      <a href="https://twitter.com/im__perfect_" target="_blank">
        <FaSquareXTwitter />
      </a>
      <a href="https://medium.com/@pranavtripathi79" target="_blank">
        <FaMedium />
      </a>
    </div>
  );
};

export default HeaderSocials;
